import styled from "styled-components";

export const SimpleMessageDialogBox = styled.div`
    display: flex;
    flex-direction: column;
    max-height: 80vh;
    max-height: 80dvh;

  @media ${props => props.theme.mediaQuery.sAndAbove} {
    min-width: 300px;
    min-height: 200px;
    max-width: 600px;
  }

  @media ${props => props.theme.mediaQuery.mAndAbove} {
    min-width: 500px;
  }
`